import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Avatar, Paper } from "@mui/material";
import * as constants from "../../constants";
import moment from "moment";
import GroupPostBar from "../GroupPostBar";
import CourseSlider from "../../CourseSlider";
import GroupAbout from "../GroupAbout";
import GroupPostAction from "../GroupPostAction/GroupPostAction";
import Link from "next/link";
import style from "./PostView.module.css";
import Image from "next/image";
import InArticleAds from "../../GoogleAdsense/InArticleAds";
import SignUpModal from "../../ModalContent/SignUpModal/SignUpModal";
import { useMediaQuery } from "@mui/material";

const BASE_URL = constants.BASE_URL;

const PostView = ({ groupID, singleGroup, groupOwner, isLoggedIn, adsId }) => {
  const [allGroupPosts, setAllGroupPosts] = useState([]);
  const [expandedPosts, setExpandedPosts] = useState([]);

  let slot = 2741792373;
  let In_article = 6999218691;

  //sign up modal
  const [openSingUp, setOpenSignUp] = React.useState(false);
  const handleSignUpClose = () => {
    setOpenSignUp(false);
  };

  const handleSignUpOpen = () => {
    setOpenSignUp(true);
  };

  const handleSingleGroupPost = () => {
    fetch(`${BASE_URL}/group/${groupID}/details/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        data.sort((a, b) => {
          return new Date(b.created_date) - new Date(a.created_date);
        });
        setAllGroupPosts(data);
        setExpandedPosts(new Array(data.length).fill(false));
      });
  };

  React.useEffect(() => {
    handleSingleGroupPost();
  }, [groupID]);

  const toggleExpanded = (index) => {
    const newArray = [...expandedPosts];
    newArray[index] = !newArray[index];
    setExpandedPosts(newArray);
  };

  const isMobile = useMediaQuery("(max-width:425px)");
  if (!allGroupPosts) return <p>No profile data</p>;
  return (
    <>
      <Row className="justify-content-center">
        <Col md={7}>
          {groupOwner.role == "Creator" || groupOwner.role == "member" ? (
            <div className="pt-2">
              <GroupPostBar
                groupOwner={groupOwner}
                handleSingleGroupPost={handleSingleGroupPost}
                groupID={groupID}
                singleGroup={singleGroup}
              />
            </div>
          ) : null}

          {allGroupPosts.map((post, idx) => {
            const isThirdPost = (idx + 1) % 3 === 0;
            return (
              <React.Fragment key={idx}>
                <Paper className="rounded-3 my-2">
                  <div className="post-user p-2">
                    <div className="post-user-info">
                      <div className="avatar">
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            border: 1,
                            borderColor: "grey.500",
                          }}
                          alt={
                            post.group_name
                              ? post.group_name
                              : post.user_first_name
                          }
                          src={
                            post.group_profile_pic
                              ? post.group_profile_pic
                              : post.user_profile_pic
                          }
                        />
                      </div>
                      <div className="profile">
                        <span className="profile-name">
                          {post.group_name
                            ? post.group_name
                            : post.user_first_name}
                        </span>

                        <span className="post-time">
                          <Link
                            href={{
                              pathname: `/post/${post.id}`,
                              query: {
                                keyword: `${
                                  post.title_of_research_article
                                    ? "summary"
                                    : "thought"
                                }`,
                              },
                            }}
                          >
                            <a target="_blank">
                              {moment(post?.created_date).format("DD-MM-YYYY")}
                            </a>
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="text-break p-2">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: expandedPosts[idx]
                          ? post.description || ""
                          : post.description && post.description.length > 400
                          ? post.description.slice(0, 400) + "..."
                          : post.description || "",
                      }}
                    />

                    {post.description && post.description.length > 400 && (
                      <span
                        className={`${style.expandPost}`}
                        onClick={() => toggleExpanded(idx)}
                      >
                        {expandedPosts[idx] ? "See less" : "See more"}
                      </span>
                    )}
                  </div>

                  {post.pic_upload && (
                    <Link
                      href={{
                        pathname: `/post/${post.id}`,
                        query: {
                          keyword: `${
                            post.title_of_research_article
                              ? "summary"
                              : "thought"
                          }`,
                        },
                      }}
                    >
                      <a target="_blank">
                        <Image
                          className={`${style.post_img} pt-2`}
                          width="95%"
                          height="80%"
                          loading="lazy"
                          layout="responsive"
                          src={post.pic_upload}
                          alt={post?.group_name}
                        />
                      </a>
                    </Link>
                  )}

                  {/*--------------- Summary Post ---------------------*/}
                  {post.title_of_research_article && (
                    <div className="fb-card-body simple-text-card simple-image-card card-padding px-2">
                      <div className="p-1">
                        <p>
                          <b>Title of research article</b>
                        </p>
                        {post.title_of_research_article}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Objective of the study</b>
                        </p>
                        {post.objective_of_the_study}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Theoretical background</b>
                        </p>
                        {post.theoritical_Background}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Research gap</b>
                        </p>
                        {post.research_gap}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Uniqueness of the study</b>
                        </p>
                        {post.uniqueness_of_the_study}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Data source/sample information</b>
                        </p>
                        {post.data_source_sample_information}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Research methodology</b>
                        </p>
                        {post.research_methodology}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Result & discussion</b>
                        </p>
                        {post.result_discussion}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Validity & reliability of finding</b>
                        </p>
                        {post.validity_reliability_of_finding}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Usefulness of the finding</b>
                        </p>
                        {post.usefulness_of_the_finding}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Reference</b>
                        </p>
                        {post.reference}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Annex</b>
                        </p>
                        {post.annex}
                      </div>
                      <div className="p-1">
                        <p>
                          <b>Keyword</b>
                        </p>
                        {post.keyword}
                      </div>
                      <div className="p-1">
                        {post.file1 && (
                          <Link href={post.file1} passHref legacyBehavior>
                            <a target="_blank" rel="noopener noreferrer">
                              File-1
                            </a>
                          </Link>
                        )}
                        <br />
                        {post.file2 && (
                          <Link href={post.file2} passHref legacyBehavior>
                            <a target="_blank" rel="noopener noreferrer">
                              File-2
                            </a>
                          </Link>
                        )}
                      </div>
                    </div>
                  )}

                  <GroupPostAction
                    post={post}
                    isLoggedIn={isLoggedIn}
                    handleSingleGroupPost={handleSingleGroupPost}
                  />
                </Paper>
                {isThirdPost && (
                  <InArticleAds slot={In_article} adsId={adsId} />
                )}
              </React.Fragment>
            );
          })}
        </Col>
        <Col md={5}>
          <div className="mt-2">
            <InArticleAds slot={slot} adsId={adsId} />
          </div>
          <GroupAbout groupID={groupID} />
          <div className={`${isMobile ? "pt-2" : "p-4"}`}>
            <CourseSlider />
          </div>
        </Col>
      </Row>
      <>
        <SignUpModal
          open={openSingUp}
          handleClose={handleSignUpClose}
          handleOpen={handleSignUpOpen}
        />
      </>
    </>
  );
};

export default PostView;
